import React, { Component } from 'react';
import { Table, Row, Col, Modal, Button, FormGroup, ControlLabel } from 'react-bootstrap';
import IconButton from '../FormComponents/IconButton';
import Pagination from 'react-js-pagination';
import { browserHistory } from 'react-router';
import { DropdownList, DateTimePicker } from 'react-widgets';
import moment from 'moment';
import FileSaver from 'file-saver';

const User = (props)=>{
  let {auth,userid,users,onChange} = props;
  if( auth.type ==="admin" || auth.type ==="supervisor"){
    let user=(users&&userid)?users.find(u=>u._id===userid):undefined;
    let all_users=[{name:'All'},...users];
    return <DropdownList name="user"
      data={all_users}
      value={user}
      textField={item=>{
        return !item?'':!item.userid?item.name:`${item.userid} - ${item.name}`
      }}
      filter="contains"
      onChange={onChange} />
  } else {
    return <p>{auth.name}</p>
  }
}

const Group = (props)=>{
  let {auth,group,users,onChange} = props;
  if( auth.type ==="admin" || auth.type ==="supervisor"){
    let all_groups=['All',...new Set((users||[]).map(u=>u.group))];
    return <DropdownList name="group"
      data={all_groups}
      value={group||'All'}
      filter="contains"
      onChange={onChange} />
  } else {
    return <p>{auth.group}</p>
  }
}

const BonusGroup = (props)=>{
  let {auth,bonus_group,users,onChange} = props;
  if( auth.type ==="admin" || auth.type ==="supervisor"){
    let all_bonus_groups=['All',...new Set((users||[]).map(u=>u.bonus_group).filter(Boolean))];
    return <DropdownList name="bonus_group"
      data={all_bonus_groups}
      value={bonus_group||'All'}
      filter="contains"
      onChange={onChange} />
  } else {
    return <p>{auth.bonus_group}</p>
  }
}

const Position = (props)=>{
  let {auth,department,users,onChange} = props;
  if( auth.type ==="admin" || auth.type ==="supervisor"){
    let all_departments=['All',...new Set((users||[]).map(u=>u.department).filter(Boolean))];
    return <DropdownList name="department"
      data={all_departments}
      value={department||'All'}
      filter="contains"
      onChange={onChange} />
  } else {
    return <p>{auth.department}</p>
  }
}

const BONUS_RATE_OPTIONS = [
  {l:'0%',v:0},{l:'0.5%',v:.005},{l:'1%',v:.01},{l:'1.5%',v:.015},{l:'2%',v:.02},
  {l:'2.5%',v:.025},{l:'3%',v:.03},{l:'3.5%',v:.035},{l:'4%',v:.04},{l:'4.5%',v:.045},
  {l:'5%',v:.05},{l:'5.5%',v:.055},{l:'6%',v:.06},{l:'6.5%',v:.065},{l:'7%',v:.07},
  {l:'7.5%',v:.075},{l:'8%',v:.08},{l:'8.5%',v:.085},{l:'9%',v:.09},{l:'9.5%',v:.095},
  {l:'10%',v:.1},{l:'10.5%',v:.105},{l:'11%',v:.11}
];

class WorkSheets extends Component{
  constructor(props){
    super(props);
    let fd,td;
    let {fromdate,todate,page,pagesize,userid,group,bonus_group,department,verified,date_override}=this.props.location.query;
    if(fromdate){
      fd = moment(fromdate+'01').toDate();
    } else {
      fd = moment().startOf('month').subtract(1,'months').toDate();
    }
    if(todate){
      td = moment(todate+'01').toDate();
    } else {
      td = moment().startOf('month').toDate();
    }
    this.state={
      deleteModal:false,
      modalMessage:"",
      modalCallback:()=>false,
      batchConfirmModal:false,
      page:+page||1,
      pagesize:+pagesize||10,
      fromdate:fd,
      todate:td,
      userid:userid,
      group,
      bonus_group,
      department,
      verified:!verified?null:verified==='true',
      date_override:!date_override?null:date_override==='true',
      batch_bonus_rate:null
    };
    let ut=this.props.user.type;
    if(ut === 'admin'||ut==='supervisor'){
      this.props.loadUsers();
    }
    let q=this.getCurrentQuery();
    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        ...q
      }
    })
    this.props.getWorkSheets(q);
  }

  getCurrentQuery(){
    return {
      page:this.state.page,
      pagesize:this.state.pagesize,
      verified:this.state.verified,
      date_override:this.state.date_override,
      group:this.state.group,
      bonus_group:this.state.bonus_group,
      department:this.state.department,
      fromdate:moment(this.state.fromdate).format("YYYYMM"),
      todate:moment(this.state.todate).format("YYYYMM"),
      userid:this.state.userid
    };
  }

  getBatchFilters(){
    let q = this.getCurrentQuery();
    delete q.page;
    delete q.pagesize;
    return q;
  }

  componentWillReceiveProps(props){
    const {
      location: {query:{page,pagesize,userid,group,bonus_group,department,verified,date_override,fromdate,todate}}
    } = props;

    if (page !== this.props.location.query.page || 
      pagesize !== this.props.location.query.pagesize ||
      userid !== this.props.location.query.userid ||
      group !== this.props.location.query.group ||
      bonus_group !== this.props.location.query.bonus_group ||
      department !== this.props.location.query.department ||
      verified !== this.props.location.query.verified ||
      date_override !== this.props.location.query.date_override ||
      fromdate !== this.props.location.query.fromdate ||
      todate !== this.props.location.query.todate){
      return this.props.getWorkSheets({page,pagesize,userid,group,bonus_group,department,verified,date_override,fromdate,todate});
    }
    if (props.worksheets_pdf && !this.props.worksheets_pdf) {
      const filename = `SLTIC_worksheets_${moment(this.state.fromdate).format("YYYYMM")}_${moment(this.state.todate).format("YYYYMM")}.pdf`;
      FileSaver.saveAs(props.worksheets_pdf, filename, { autoBom: false });
    }
  }

  loadWorkSheets(){
    this.props.getWorkSheets(this.getCurrentQuery());
  }
  
  handlePageChange(page,pagesize) {
    let s={page};
    pagesize && (s.pagesize=pagesize);
    this.setState(s);
    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        ...s
      }
    })
  }

  handleDateChange(date,field){
    let d=moment(date).format("YYYYMM"),s={page:1};
    s[field]=date;
    this.setState(s);
    let url = {
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        page:1
      }
    };
    url.query[field]=d;
    browserHistory.push(url);
  }

  handleUserChange(user){
    this.setState({userid:user._id,page:1});
    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        page:1,
        userid:user._id
      }
    })
  }

  handleGroupChange(group){
    group==='All'&&(group=null);
    this.setState({group,page:1});
    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        page:1,
        group
      }
    })
  }

  handleBonusGroupChange(bonus_group){
    bonus_group==='All'&&(bonus_group=null);
    this.setState({bonus_group,page:1});
    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        page:1,
        bonus_group
      }
    })
  }

  handleVerifiedChange(opt){
    let verified=opt.v;
    this.setState({page:1,verified});
    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        page:1,
        verified
      }
    })
  }

  handleDateOverrideChange(opt){
    let date_override=opt.v;
    this.setState({page:1,date_override});
    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        page:1,
        date_override
      }
    })
  }

  handlePositionChange(department){
    department==='All'&&(department=null);
    this.setState({department,page:1});
    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        page:1,
        department
      }
    })
  }

  handleBatchBonusApply(){
    let rate = this.state.batch_bonus_rate;
    if (rate === null || rate === undefined){
      return;
    }
    this.props.batchUpdateWorkSheetsBonus(this.getBatchFilters(), rate);
  }

  openBatchConfirm(){
    let rate = this.state.batch_bonus_rate;
    if (rate === null || rate === undefined){
      return;
    }
    this.setState({batchConfirmModal:true});
  }

  downloadPDF(){
    this.props.getWorkSheetsPDF(this.getBatchFilters());
  }

  renderPagingControls(idSuffix){
    const isPrivileged = this.props.user.type === "admin" || this.props.user.type === "supervisor";
    const dropdownId = idSuffix ? `pagesize-${idSuffix}` : "pagesize";
    return (
      <Row>
        <Col sm={3}>
          <FormGroup className="pagesize-group">
            <ControlLabel htmlFor={dropdownId}>Page size</ControlLabel>
            <DropdownList id={dropdownId} name="pagesize"
              data={[10,25,100]}
              value={this.state.pagesize}
              onChange={ps=>this.handlePageChange(1,ps)} />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <Pagination
            activePage={this.state.page}
            itemsCountPerPage={this.state.pagesize}
            totalItemsCount={this.props.worksheets_count}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange.bind(this)}
            />
        </Col>
        <Col sm={3}>
          {isPrivileged &&
          <FormGroup>
            <Button className="download-pdf-btn" disabled={this.props.worksheets_pdf_loading} onClick={() => this.downloadPDF()}>Download PDF</Button>
          </FormGroup>}
        </Col>
      </Row>
    );
  }

  render(){
    const closeModal=()=>{this.setState({deleteModal:false})}
    const isPrivileged = this.props.user.type === "admin" || this.props.user.type === "supervisor";
    const selectedRate = BONUS_RATE_OPTIONS.find(o=>o.v===this.state.batch_bonus_rate);
    const rateLabel = selectedRate ? selectedRate.l : "";
    const selectedUser = (this.state.userid && this.props.users)
      ? this.props.users.find(u=>u._id===this.state.userid)
      : null;
    const userLabel = selectedUser ? `${selectedUser.userid} - ${selectedUser.name}` : this.state.userid;
    const filterDetails = [
      this.state.fromdate ? `From: ${moment(this.state.fromdate).format("MMMM YYYY")}` : null,
      this.state.todate ? `To: ${moment(this.state.todate).format("MMMM YYYY")}` : null,
      this.state.verified === null ? "Verified: All" : `Verified: ${this.state.verified ? "Yes" : "No"}`,
      this.state.date_override === null ? "Date override: All" : `Date override: ${this.state.date_override ? "Enabled" : "Disabled"}`,
      this.state.group ? `Group: ${this.state.group}` : "Group: All",
      this.state.bonus_group ? `Bonus group: ${this.state.bonus_group}` : "Bonus group: All",
      this.state.department ? `Position: ${this.state.department}` : "Position: All",
      this.state.userid ? `User: ${userLabel}` : "User: All"
    ].filter(Boolean);
    if (this.props.worksheets_loaded){
      return (
        <div id="worksheets">
          <Row>
            <Col sm={6}>
              <h1>Work Sheets</h1>
            </Col>
            <Col sm={6}>
              <IconButton type="create" redirect="/worksheets/new" right>Create</IconButton>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <ControlLabel htmlFor="fromdate">From</ControlLabel>
                <DateTimePicker id="fromdate"
                  time={false}
                  onChange={d=>this.handleDateChange(d,'fromdate')}
                  format="MMMM YYYY"
                  value={this.state.fromdate}
                  views={["year"]}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel htmlFor="todate">To</ControlLabel>
                <DateTimePicker id="todate"
                  time={false}
                  onChange={d=>this.handleDateChange(d,'todate')}
                  format="MMMM YYYY"
                  value={this.state.todate}
                  views={["year"]}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel htmlFor="verified">Verified</ControlLabel>
                <DropdownList id="verified" name="verified"
                  data={[{l:'All',v:null},{l:'Yes',v:true},{l:'No',v:false}]}
                  value={this.state.verified}
                  textField="l"
                  valueField="v"
                  onChange={this.handleVerifiedChange.bind(this)} />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel htmlFor="date-override">Date override</ControlLabel>
                <DropdownList id="date-override" name="date_override"
                  data={[{l:'All',v:null},{l:'Enabled',v:true},{l:'Disabled',v:false}]}
                  value={this.state.date_override}
                  textField="l"
                  valueField="v"
                  onChange={this.handleDateOverrideChange.bind(this)} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <ControlLabel htmlFor="group">Group</ControlLabel>
                <Group auth={this.props.user} group={this.state.group} users={this.props.users} onChange={this.handleGroupChange.bind(this)}/>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel htmlFor="bonus_group">Bonus group</ControlLabel>
                <BonusGroup auth={this.props.user} bonus_group={this.state.bonus_group} users={this.props.users} onChange={this.handleBonusGroupChange.bind(this)}/>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel htmlFor="department">Position</ControlLabel>
                <Position auth={this.props.user} department={this.state.department} users={this.props.users} onChange={this.handlePositionChange.bind(this)}/>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel htmlFor="user">User</ControlLabel>
                <User auth={this.props.user} userid={this.state.userid} users={this.props.users} onChange={this.handleUserChange.bind(this)}/>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={3} >
              <FormGroup>
                <ControlLabel>Records</ControlLabel>
                <p className="form-control-static records-count">
                  {this.props.worksheets_loading ? 'Loading...' : `${this.props.worksheets_count} ( ${this.props.worksheets_total_count} )`}
                </p>
              </FormGroup>
            </Col>
          </Row>
          <hr />
          {isPrivileged &&
          <div>
            <Row>
              <Col md={5}>
                <FormGroup className="batch-bonus-group">
                  <ControlLabel htmlFor="batch-bonus-rate">Batch bonus (%)</ControlLabel>
                  <DropdownList id="batch-bonus-rate"
                    data={BONUS_RATE_OPTIONS}
                    value={this.state.batch_bonus_rate}
                    textField="l"
                    valueField="v"
                    onChange={o=>this.setState({batch_bonus_rate:o.v})}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                    <Button
                      bsStyle="primary"
                      disabled={this.props.worksheets_bonus_updating || this.state.batch_bonus_rate === null}
                      onClick={() => this.openBatchConfirm()}
                    >
                      Apply to selection
                    </Button>
                </FormGroup>
              </Col>
            </Row>
            <hr />
          </div>}
          {this.renderPagingControls("top")}
          <Table className="crud-table" responsive>
            <thead>
              <tr>
                <th>User ID</th>
                <th>User</th>
                <th>Month</th>
                <th className="hidden-xs">Salary</th>
                <th className="hidden-xs">Bonus</th>
                <th>Salary Total</th>
                <th className="hidden-xs">Verified</th>
                <th className="hidden-xs">Date override</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.props.worksheets.map(worksheet=>{
                const dateOverrideEnabled = worksheet.date_override_enabled !== undefined
                  ? worksheet.date_override_enabled
                  : worksheet.date_override;
                const dateOverrideLabel = dateOverrideEnabled === true
                  ? 'Yes'
                  : dateOverrideEnabled === false
                    ? 'No'
                    : '-';
                return (
                <tr key={worksheet._id}>
                  <td>{worksheet.user.userid}</td>
                  <td>{worksheet.user.name}</td>
                  {/* <td><LinkContainer to={`/worksheets/${worksheet._id}`}><a>{worksheet.month}</a></LinkContainer></td> */}
                  <td>{moment(worksheet.month+'01').format('MMM-YY')}</td>
                  <td className="hidden-xs">{worksheet.sum.toFixed(2)}</td>
                  <td className="hidden-xs">{worksheet.bonus.toFixed(2)}</td>
                  <td>{worksheet.sum_total.toFixed(2)}</td>
                  <td className="hidden-xs">{worksheet.verified?'Yes':'No'}</td>
                  <td className="hidden-xs">{dateOverrideLabel}</td>
                  <td>
                    <IconButton type="delete" onClick={()=>{
                      this.setState({
                        deleteModal:true,
                        modalMessage:`Are you sure you want to delete ${worksheet.month}? This action is permanent.`,
                        modalCallback:()=>{this.props.deleteWorkSheet(worksheet._id);this.loadWorkSheets();closeModal();}
                      });
                    }}>Delete</IconButton>
                    <IconButton type="edit" redirect={"/worksheets/"+worksheet._id}>Edit</IconButton>
                  </td>
                </tr>
                );
              })}
            </tbody>
          </Table>
          {this.renderPagingControls("bottom")}
          <Modal show={this.state.deleteModal} onHide={closeModal}>
            <Modal.Header>Confirm delete...</Modal.Header>
            <Modal.Body>{this.state.modalMessage}</Modal.Body>
            <Modal.Footer>
              <Button onClick={closeModal}>Cancel</Button>
              <Button onClick={this.state.modalCallback}>Confirm</Button>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.batchConfirmModal} onHide={()=>this.setState({batchConfirmModal:false})}>
            <Modal.Header>Confirm batch bonus...</Modal.Header>
            <Modal.Body>
              This will set the bonus rate to {rateLabel} for {this.props.worksheets_count} worksheet{this.props.worksheets_count===1?'':'s'}.
              <br />
              Filters:
              {filterDetails.map(detail=>(
                <div key={detail}>{detail}</div>
              ))}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={()=>this.setState({batchConfirmModal:false})}>Cancel</Button>
              <Button
                disabled={this.props.worksheets_bonus_updating}
                onClick={()=>{
                  this.setState({batchConfirmModal:false});
                  this.handleBatchBonusApply();
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      );
    }
    else {
      return (
        <div className="loading">
          Loading...
        </div>
      );
    }
  }
}

export default WorkSheets;
